import { Routes } from '@angular/router';
import { AmplifyGuard, AuthGuard, NoAuthGuard, NotFound404Component } from 'projects/lib-shared-core/src/public-api';
import { SvcPublicLayoutComponent } from '../layout/public/public-layout.component';

export const authRoutes: Routes = [
  {
    path: '',
    canActivate: [NoAuthGuard],
    component: SvcPublicLayoutComponent,
    children: [
      {
        canActivate: [NoAuthGuard, AmplifyGuard],
        path: 'forgot-password',
        loadChildren: () => import('./forgot-password/forgot-password.module').then((m) => m.AuthForgotPasswordModule),
      },
      {
        canActivate: [NoAuthGuard, AmplifyGuard],
        path: 'reset-password',
        loadChildren: () => import('./reset-password/reset-password.module').then((m) => m.AuthResetPasswordModule),
      },
      {
        canActivate: [NoAuthGuard],
        path: 'sign-in',
        loadChildren: () => import('./sign-in/sign-in.module').then((m) => m.AuthSignInModule),
      },
      {
        canActivate: [NoAuthGuard],
        path: 'global-sign-in',
        loadChildren: () => import('./sign-in/sign-in.module').then((m) => m.AuthSignInModule),
      },
      {
        path: 'user-locked',
        loadChildren: () => import('./user-locked/user-locked.module').then((m) => m.UserLockedModule),
      },
    ],
  },
  {
    path: '',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: SvcPublicLayoutComponent,
    children: [
      {
        path: 'sign-out',
        loadChildren: () => import('./sign-out/sign-out.module').then((m) => m.AuthSignOutModule),
      },
      {
        path: 'expired-password',
        loadChildren: () => import('./expired-password/expired-password.module').then((m) => m.AuthExpiredPasswordModule),
      },
      {
        path: 'multi-signin',
        loadChildren: () => import('./sign-in/sign-in.module').then((m) => m.AuthSignInModule),
        data: { isMultiSignin: true },
      },
      {
        path: 'multi-signin/:userId',
        loadChildren: () => import('./sign-in/sign-in.module').then((m) => m.AuthSignInModule),
        data: { isMultiSignin: true },
      },
    ],
  },
  { path: 'default.asp', pathMatch: 'full', redirectTo: 'signed-in-redirect' },
  {
    path: 'page-cant-be-load',
    component: SvcPublicLayoutComponent,
    loadChildren: () => import('projects/lib-shared-core/src/lib/features/page-cant-be-load/page-cant-be-load.module').then((m) => m.PageCantBeLoadModule),
  },
  {
    path: '**',
    component: SvcPublicLayoutComponent,
    children: [{ path: '**', component: NotFound404Component }],
  },
];
